namespace Ordini {
    // Costanti globali
    const KeyupRegex = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    const KeySpecials = ["Enter", "Backspace", "Control", "Delete"];
    const operationSecondTimeoutMs = 1000; // 1 second
    const annoAttuale = new Date().getFullYear();

    let KeyupTimer: NodeJS.Timeout;

    // ============================================================================
    // ENUMS
    // ============================================================================

    enum TabsFiltriCatalogo {
        ND = 0,
        PIU_CONSULTATI = 1,
        NOVITA = 2,
        IN_EVIDENZA = 5,
        PIU_VENDUTI = 11,
        IN_SCADENZA = 20,
        IN_PROMO = 6,
        PROMO_R = 7,
        PROMO_C = 8,
        PIU_VOTATI = 15,
        GIA_ACQUISTATI = 16,
        RACCOMANDATI = 30,
        SUGGERITI = 31,
        INEVASI = 32
    }

    // ============================================================================
    // INTERFACES E CLASSI
    // ============================================================================

    type InfiniteScOpt = Controlli.UtilityTabella.BaseInfiniteScrollOptions;

    interface CarrelloConfig {
        urlAggiornamento: string;
        contextRowSelector: string;
        refreshTotaliUrl: string;
        mainBodyRefresh?: string;
        refreshUrl?: string;
        executeCallOnChangeQta?: boolean;
    }

    interface DataAttributeConfig {
        btnAddProduct: string;
        qtaSelector: string;
        idProdotto: string;
        idRigaLista: string;
        idListino: string;
        idUnitaMisura: string;
    }

    class AggiuntaArticoliCarrelloResponse extends Controlli.Utility.BaseJSONResponse {
        NumeroOrdine: string;
        CodiceArticolo: string;
    }

    class AggiuntaArticoliCarrelloRequest {
        IdProdotto: string;
        Quantita: number;
        IdListaRiga: number | null;
        IdListino: number;
        IdUnitaMisura: number;
        IsPrezzoModificatoManualmente: boolean;
        Prezzo: string;

        constructor(idProdotto: string, quantita: number, idListino: number, idUnitaMisura: number, isPrezzoModificatoManualmente: boolean, prezzo: string, idListaRiga?: number | null) {
            this.IdProdotto = idProdotto;
            this.Quantita = quantita;
            this.IdListino = idListino;
            this.IdUnitaMisura = idUnitaMisura;
            this.IdListaRiga = idListaRiga ?? null;
            this.IsPrezzoModificatoManualmente = isPrezzoModificatoManualmente;
            this.Prezzo = prezzo;
        }
    }

    export class FiltroOrdini extends Controlli.UtilityTabella.BaseFiltriListaDto {
        IdEsercizio: number;
        AziendaId: number;
        ListaAgentiId: Array<number>;
        TipoOrdine: number;
    }

    class FiltroCatalogoOrdiniDto extends Controlli.UtilityTabella.BaseFiltriListaDto {
        CategoriaId?: number;
        SottoCategoriaId?: number;
        MarcheSelezionate: number[];
        ElencoTagSelezionati: number[];
        IsNovita: boolean;
        EvidenzaArticoli?: TabsFiltriCatalogo;
        ListinoEvidenzaSelezionato?: number;
        CatalogoSelezionatoId?: number;
        ConnectionId: string;
    }

    // ============================================================================
    // ELENCO NAMESPACE
    // ============================================================================

    export namespace Elenco {
        const dataAttrRicerca = "sav-ricerca-ordine";
        const dataAttrReset = "sav-reset-ordini-filtro";
        const dataAttrDataFrom = "dataFromOrdineElenco";
        const dataAttrDataTo = "dataToOrdineElenco";

        export function Init(baseUrlFiltro: string, tipoElenco: number, divTabella: string, bodyTabella: string, rigaTabella: string, loadStatusClass: string, initRowPerPage: number): void {
            const filtroOrdini = {
                PaginaAttuale: 1,
                PagineTotali: 2,
                RighePerPagina: initRowPerPage,
                GenericId: 0,
                RicercaTestuale: '',
                DataFine: null,
                DataInizio: null,
                IdEsercizio: annoAttuale - 2000,
                AziendaId: 1,
                TipoOrdine: tipoElenco,
                ListaAgentiId: []
            } as FiltroOrdini;

            const opt: InfiniteScOpt = {
                divTabella,
                bodyTabella,
                baseUrlFiltro,
                rigaTabella,
                loadStatusClass,
            };

            const tabella = Controlli.UtilityTabella.InitInfiniteScroll(opt, Controlli.Utility.HttpMethod.POST, filtroOrdini, null);

            //Init filtro ricerca testuale
            $(`[data-${dataAttrRicerca}]`).on("keyup", function (e) {
                const searchTerm = $(this).val() as string;
                if (searchTerm !== filtroOrdini.RicercaTestuale && (searchTerm === '' || KeyupRegex.test(searchTerm) || KeySpecials.includes(e.key))) {
                    AggiornaTabella(opt, tabella, filtroOrdini);
                }
            });
            //Init filtro data DA - A
            $(`#${dataAttrDataFrom}, #${dataAttrDataTo}`).on("change", () => AggiornaTabella(opt, tabella, filtroOrdini));
            //Init filtro reset filtro
            $(`[data-${dataAttrReset}]`).on("click", () => ResetFiltri());
        }

        function AggiornaTabella(opzioni: InfiniteScOpt, infiniteScrollTable: JQuery<HTMLElement>, filtro: FiltroOrdini): void {
            filtro.RicercaTestuale = $(`[data-${dataAttrRicerca}]`).val() as string;
            filtro.DataInizio = $(`#${dataAttrDataFrom}`).val() as string;
            filtro.DataFine = $(`#${dataAttrDataTo}`).val() as string;

            clearTimeout(KeyupTimer);
            KeyupTimer = setTimeout(() => Controlli.Utility.fadeOutFadeIn($(opzioni.bodyTabella), () => {
                Controlli.UtilityTabella.ResetInfiniteScroll(opzioni, infiniteScrollTable, Controlli.Utility.HttpMethod.POST, filtro);
            }), operationSecondTimeoutMs);
        }

        function ResetFiltri(): void {
            $(`[data-${dataAttrRicerca}]`).val(null);
            $(`#${dataAttrDataFrom}`).val(null);
            $(`#${dataAttrDataTo}`).val(null);
            $(`#${dataAttrDataTo}`).trigger("change");
        }
    }

    // ============================================================================
    // CATALOGO NAMESPACE
    // ============================================================================

    export namespace Catalogo {
        let filtriAttivati: boolean = false;
        let Filtro: FiltroCatalogoOrdiniDto;
        let UrlAggiungiProdottiPost: string;
        let UrlAggiornaTotali: string;
        let ContextCatalogo: string;

        const dataAttrConfig = {
            tabFiltro: "sav-catalogo-ordini-articoloevidenza",
            ricercaTestuale: "sav-ricerca-catalogo-ordine-lista",
            selectListino: "sav-catalogo-ordine-listino",
            listCataloghi: "sav-cataloghifilter-catalogo-ordine-lista",
            listCategorie: "sav-categorie-catalogo-ordine-lista",
            listSottocategorie: "sav-sottocategorie-catalogo-ordine-lista",
            checkboxMarche: "sav-marche-catalogo-ordine-lista",
            badgeTags: "sav-listatag-catalogo-ordine-lista",
            btnClearFilter: "sav-puliscifiltri-catalogo-ordine-lista",
        };

        export function Init(
            baseUrlFiltro: string,
            divTabella: string,
            bodyTabella: string,
            context: string,
            rigaTabella: string,
            loaderInfiniteScroll: string,
            initRowPerPage: number,
            urlAddOrder: string,
            urlAggiornamento: string
        ): void {
            ResetFiltro(initRowPerPage);
            UrlAggiungiProdottiPost = urlAddOrder;
            ContextCatalogo = context;
            UrlAggiornaTotali = urlAggiornamento;

            const opzioni: InfiniteScOpt = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass: loaderInfiniteScroll };
            const tabella = Controlli.UtilityTabella.InitInfiniteScroll(
                opzioni, Controlli.Utility.HttpMethod.POST, Filtro,
                (items: NodeList) => {
                    Ordini.Carrello.SetupProductButtons({
                        urlAggiornamento: UrlAggiungiProdottiPost,
                        contextRowSelector: ContextCatalogo,
                        refreshTotaliUrl: UrlAggiornaTotali,
                        selector: $(items),
                        executeCallOnChangeQta: false
                    });
                }
            );

            // Inizializza Select2 per le marche
            const $selectMarche = $(`[data-${dataAttrConfig.checkboxMarche}]`);
            if ($selectMarche.length > 0) {
                $selectMarche.select2({
                    placeholder: "Seleziona marche...",
                    theme: 'bootstrap-5',
                    containerCssClass: "select2--small",
                    dropdownCssClass: "select2--small",
                    allowClear: false,
                    width: '100%',
                    language: {
                        noResults: function () {
                            return "Nessuna marca trovata";
                        }
                    },
                    templateSelection: function (data) {
                        // Personalizza il rendering dei tag selezionati
                        var $selection = $('<span class="text-white fw-semibold"></span>');
                        $selection.text(data.text);
                        return $selection;
                    }
                });
            }

            //Filtro 
            FiltroArticoliEvidenza(opzioni, tabella);
            FiltroRicercaTestuale(opzioni, tabella);
            FiltroTipologiaLista(opzioni, tabella);
            FiltroCataloghi(opzioni, tabella);
            FiltroCategorie(opzioni, tabella);
            FiltroMarche(opzioni, tabella, $selectMarche);
            FiltroTags(opzioni, tabella);

            //Definisco l'evento di pulizia filtro
            $(`[data-${dataAttrConfig.btnClearFilter}]`).off("click").on("click", function () {
                if (filtriAttivati) {
                    ResetFiltro(initRowPerPage);
                    $selectMarche.val(null).trigger('change');
                    ReloadTable(opzioni, tabella);
                    CambiaStileBottoneResetFiltri();
                }
            });
        }

        //Gestione logiche singoli filtri -----------------------------------------------------------
        function FiltroCategorie(opzioni: InfiniteScOpt, tabella: JQuery<HTMLElement>): void {
            $(`[data-${dataAttrConfig.listCategorie}], [data-${dataAttrConfig.listSottocategorie}]`).off("click").on("click", function () {
                const categoria = $(this).data(dataAttrConfig.listCategorie) as number | null;
                const sottocategoria = $(this).data(dataAttrConfig.listSottocategorie) as number | null;

                UpdateCategorieUI($(this), categoria, sottocategoria);
                Filtro.CategoriaId = categoria;
                Filtro.SottoCategoriaId = sottocategoria;

                CambiaStileBottoneResetFiltri(true);
                ReloadTable(opzioni, tabella);
            });
        }
        function UpdateCategorieUI($filtroCategorie: JQuery<HTMLElement>, categoria: number | null, sottocategoria: number | null): void {
            $(`[data-${dataAttrConfig.listCategorie}] h5, [data-${dataAttrConfig.listSottocategorie}] h5`).removeClass("text-info");
            $filtroCategorie.find("h5").addClass("text-info");

            if (sottocategoria != null) {
                $(`[data-${dataAttrConfig.listCategorie}='${categoria}']`).not(`[data-${dataAttrConfig.listSottocategorie}]`).find("h5").addClass("text-info");
            } else {
                $(`[data-${dataAttrConfig.listCategorie}]`).not(`[data-${dataAttrConfig.listSottocategorie}]`).each(function () {
                    const catId = $filtroCategorie.data(dataAttrConfig.listCategorie);
                    if (catId !== categoria) {
                        $filtroCategorie.next("div.collapse").removeClass("show");
                    }
                });

                $(`[data-${dataAttrConfig.listCategorie}] , [data-${dataAttrConfig.listSottocategorie}]`).addClass("collapsed");
                $filtroCategorie.removeClass("collapsed");
            }
        }

        function UpdateCataloghiUI($filtroCataloghi: JQuery<HTMLElement>, categoria: number | null): void {
            $(`[data-${dataAttrConfig.listCataloghi}] h5`).removeClass("text-info");
            $filtroCataloghi.find("h5").addClass("text-info");
        }
        function FiltroArticoliEvidenza(opzioni: InfiniteScOpt, tabella: JQuery<HTMLElement>): void {
            $(`[data-${dataAttrConfig.tabFiltro}]`).off("click").on("click", function () {
                const newTipo = $(this).data(dataAttrConfig.tabFiltro) as TabsFiltriCatalogo;
                if (Filtro.EvidenzaArticoli !== newTipo) {
                    Filtro.EvidenzaArticoli = newTipo;
                    Filtro.IsNovita = newTipo === TabsFiltriCatalogo.NOVITA;
                    CambiaStileBottoneResetFiltri(true);
                    ReloadTable(opzioni, tabella);
                }
            });
        }
        function FiltroRicercaTestuale(opzioni: InfiniteScOpt, tabella: JQuery<HTMLElement>): void {
            $(`[data-${dataAttrConfig.ricercaTestuale}]`).off("keyup").on("keyup", function (event) {
                const searchTerm = $(this).val() as string;
                if (searchTerm !== Filtro.RicercaTestuale && (searchTerm === '' || KeyupRegex.test(searchTerm) || KeySpecials.includes(event.key))) {
                    Filtro.RicercaTestuale = searchTerm;
                    CambiaStileBottoneResetFiltri(true);
                    clearTimeout(KeyupTimer);
                    KeyupTimer = setTimeout(() => ReloadTable(opzioni, tabella), operationSecondTimeoutMs);
                }
            });
        }
        function FiltroTipologiaLista(opzioni: InfiniteScOpt, tabella: JQuery<HTMLElement>): void {
            $(`[data-${dataAttrConfig.selectListino}]`).off("change").on("change", function () {
                Filtro.ListinoEvidenzaSelezionato = $(this).find('option:selected').val() as number;
                CambiaStileBottoneResetFiltri(true);
                ReloadTable(opzioni, tabella);
            });
        }
        function FiltroTags(opzioni: InfiniteScOpt, tabella: JQuery<HTMLElement>): void {
            $(`[data-${dataAttrConfig.badgeTags}]`).off("click").on("click", function () {
                $(this).toggleClass("bg-info text-primary border border-primary");
                const tagId = $(this).data(dataAttrConfig.badgeTags) as number;
                const index = Filtro.ElencoTagSelezionati.indexOf(tagId);

                Filtro.ElencoTagSelezionati = index === -1
                    ? [...Filtro.ElencoTagSelezionati, tagId]
                    : Filtro.ElencoTagSelezionati.filter((_, i) => i !== index);

                CambiaStileBottoneResetFiltri(true);
                ReloadTable(opzioni, tabella);
            });
        }
        function FiltroMarche(opzioni: InfiniteScOpt, tabella: JQuery<HTMLElement>, $selectMarche: JQuery<HTMLElement>): void {
            $selectMarche.on("change", function () {
                const valoriSelezionati = $(this).val() as string[];
                Filtro.MarcheSelezionate = valoriSelezionati ? valoriSelezionati.map(v => parseInt(v, 10)) : [];

                CambiaStileBottoneResetFiltri(true);
                ReloadTable(opzioni, tabella);
            });
        }
        function FiltroCataloghi(opzioni: InfiniteScOpt, tabella: JQuery<HTMLElement>): void {
            $(`[data-${dataAttrConfig.listCataloghi}]`).off("click").on("click", function () {
                const catalogo = $(this).data(dataAttrConfig.listCataloghi) as number | null;

                UpdateCataloghiUI($(this), catalogo);
                Filtro.CatalogoSelezionatoId = catalogo;

                CambiaStileBottoneResetFiltri(true);
                ReloadTable(opzioni, tabella);
            });
        }

        //Gestione reset dei filtri -----------------------------------------------------------
        function ResetFiltro(initRowPerPage: number): void {
            Filtro = {
                PaginaAttuale: 1,
                PagineTotali: 2,
                RighePerPagina: initRowPerPage,
                GenericId: 0,
                DataFine: null,
                DataInizio: null,
                RicercaTestuale: '',
                ElencoTagSelezionati: [],
                IsNovita: false,
                MarcheSelezionate: [],
                CategoriaId: null,
                EvidenzaArticoli: TabsFiltriCatalogo.ND,
                SottoCategoriaId: null,
                ListinoEvidenzaSelezionato: undefined,
                ConnectionId: $.connection.hub.id,
            } as FiltroCatalogoOrdiniDto;

            ResetUIFiltri();
        }
        function ResetUIFiltri(): void {
            $(`[data-${dataAttrConfig.tabFiltro}]`).removeClass("active");
            $(`[data-${dataAttrConfig.tabFiltro}="${TabsFiltriCatalogo.ND}"]`).addClass('active');
            $(`[data-${dataAttrConfig.selectListino}]`).prop("selectedIndex", 0);
            $(`[data-${dataAttrConfig.ricercaTestuale}]`).val("");
            $(`[data-${dataAttrConfig.listCataloghi}]`).removeClass("active show");
            $(`[data-${dataAttrConfig.listCataloghi}] h5`).removeClass("text-info");
            $(`[data-${dataAttrConfig.listCategorie}], [data-${dataAttrConfig.listSottocategorie}]`).removeClass("active show");
            $(`[data-${dataAttrConfig.listCategorie}] h5, [data-${dataAttrConfig.listSottocategorie}] h5`).removeClass("text-info");
            $(`[data-${dataAttrConfig.badgeTags}]`).removeClass("bg-info").addClass("border border-primary text-primary");
        }
        function CambiaStileBottoneResetFiltri(attiva: boolean = false): void {
            const $btn = $(`[data-${dataAttrConfig.btnClearFilter}]`);
            if (attiva) {
                $btn.removeClass("link-primary").addClass("link-secondary text-decoration-underline");
                filtriAttivati = true;
            } else {
                $btn.removeClass("text-decoration-underline link-secondary").addClass("link-primary");
                filtriAttivati = false;
            }
        }

        function ReloadTable(opzioni: InfiniteScOpt, infiniteScrollTable: any): void {
            Controlli.Utility.fadeOutFadeIn($(opzioni.bodyTabella), () => {
                Filtro.ConnectionId = $.connection.hub.id;
                Controlli.UtilityTabella.ResetInfiniteScroll(
                    opzioni,
                    infiniteScrollTable,
                    Controlli.Utility.HttpMethod.POST,
                    Filtro,
                    (items: NodeList) => {
                        Ordini.Carrello.SetupProductButtons({
                            urlAggiornamento: UrlAggiungiProdottiPost,
                            contextRowSelector: ContextCatalogo,
                            refreshTotaliUrl: UrlAggiornaTotali,
                            selector: $(items),
                            executeCallOnChangeQta: false
                        });
                    }
                );
            });
        }
    }

    // ============================================================================
    // CARRELLO NAMESPACE (rimane invariato)
    // ============================================================================

    export namespace Carrello {
        const defaultDataAttrConfig: DataAttributeConfig = {
            btnAddProduct: "btn-aggiungi-prodotto",
            qtaSelector: "qta-selector",
            idProdotto: "idart",
            idRigaLista: "idrigalista",
            idListino: "idlistino",
            idUnitaMisura: "idunitamisura"
        };

        // Store per tracking delle righe già inizializzate
        const initializedRows = new Set<string>();

        export function Init(
            mainBodySelector: string,
            refreshUrl: string,
            urlAggiornamento: string,
            totalUrl: string,
            context: string,
            selector?: JQuery<HTMLElement | NodeList>,
            executeCallOnChangeQta: boolean = false
        ): void {
            SetupProductButtons({
                urlAggiornamento,
                contextRowSelector: context,
                refreshTotaliUrl: totalUrl,
                mainBodyRefresh: mainBodySelector,
                refreshUrl,
                selector,
                executeCallOnChangeQta
            });
        }

        export function SetupProductButtons(config: CarrelloConfig & { selector?: JQuery<HTMLElement | NodeList> }): void {
            const { urlAggiornamento, contextRowSelector, refreshTotaliUrl, mainBodyRefresh, refreshUrl, selector, executeCallOnChangeQta } = config;

            // Setup per elementi già presenti nel DOM
            if (executeCallOnChangeQta && mainBodyRefresh && refreshUrl) {
                // Setup event delegation per gestire elementi caricati dinamicamente
                SetupEventChangeDelegation(urlAggiornamento, contextRowSelector, refreshTotaliUrl, mainBodyRefresh, refreshUrl, executeCallOnChangeQta);
                SetupQuantityChangeHandler(urlAggiornamento, contextRowSelector, refreshTotaliUrl, mainBodyRefresh, refreshUrl, selector);
            } else {
                // Setup event delegation per gestire elementi caricati dinamicamente
                SetupEventClickDelegation(urlAggiornamento, contextRowSelector, refreshTotaliUrl, mainBodyRefresh, refreshUrl, executeCallOnChangeQta);
                SetupAddProductHandler(urlAggiornamento, contextRowSelector, refreshTotaliUrl, selector);
            }

            // Setup listener per l'espansione delle righe di dettaglio
            SetupDetailRowExpansion(urlAggiornamento, contextRowSelector, refreshTotaliUrl, mainBodyRefresh, refreshUrl, executeCallOnChangeQta);
        }

        function SetupEventChangeDelegation(
            urlAggiornamento: string,
            contextRowSelector: string,
            refreshTotaliUrl: string,
            mainBodyRefresh?: string,
            refreshUrl?: string,
            executeCallOnChangeQta?: boolean
        ): void {

            // Rimuovi i precedenti handler delegati sull'onChange per evitare duplicati
            $(document).off('change.carrello-delegation');

            // Event delegation per il cambio quantità se necessario
            if (executeCallOnChangeQta && mainBodyRefresh && refreshUrl) {
                $(document).on(
                    `change.carrello-delegation`,
                    `[data-${contextRowSelector}-${defaultDataAttrConfig.qtaSelector}]`,
                    function () {
                        clearTimeout(KeyupTimer);
                        const $input = $(this);
                        KeyupTimer = setTimeout(() => {
                            const response = UpdateRigaOrdine(urlAggiornamento, contextRowSelector, $input);
                            if (response && Object.keys(response).length > 0) {
                                Controlli.Ajax.AjaxLoadingHTML(refreshUrl, mainBodyRefresh);
                                Controlli.Ajax.AjaxLoadingHTML(refreshTotaliUrl, "[data-sav-schermata-condizioni]");
                            }
                        }, operationSecondTimeoutMs);
                    }
                );
            }
        }

        function SetupEventClickDelegation(
            urlAggiornamento: string,
            contextRowSelector: string,
            refreshTotaliUrl: string,
            mainBodyRefresh?: string,
            refreshUrl?: string,
            executeCallOnChangeQta?: boolean
        ): void {
            // Rimuovi i precedenti handler delegati sull'onClick per evitare duplicati
            $(document).off('click.carrello-delegation');

            // Event delegation per il pulsante aggiungi prodotto
            $(document).on(
                `click.carrello-delegation`,
                `[data-${contextRowSelector}-${defaultDataAttrConfig.btnAddProduct}]`,
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const response = UpdateRigaOrdine(urlAggiornamento, contextRowSelector, $(this));
                    if (response && Object.keys(response).length > 0) {
                        Controlli.Ajax.AjaxLoadingHTML(refreshTotaliUrl, "[data-sav-schermata-condizioni]");

                        // Feedback visivo
                        const $btn = $(this);
                        const originalHtml = $btn.html();
                        $btn.html('<i class="fa-duotone fa-regular fa-check"></i>').prop('disabled', true);
                        setTimeout(() => {
                            $btn.html(originalHtml).prop('disabled', false);
                        }, 1000);
                    }
                }
            );
        }

        function SetupDetailRowExpansion(
            urlAggiornamento: string,
            contextRowSelector: string,
            refreshTotaliUrl: string,
            mainBodyRefresh?: string,
            refreshUrl?: string,
            executeCallOnChangeQta?: boolean
        ): void {
            // Listener per il click sulle righe principali che caricano il dettaglio
            $(document).on('click.detail-expansion', '[data-sav-dettaglio-pulsanteordine]', function (e) {
                e.preventDefault();

                const $this = $(this);
                const $currentRow = $this.closest('tr');
                const productId = $this.data('sav-dettaglio-pulsanteordine');

                // Attendi che il contenuto sia caricato
                setTimeout(() => {
                    // Cerca la riga di dettaglio che è stata appena caricata
                    const $detailRow = $currentRow.next('.riga-dettaglioordine');

                    if ($detailRow.length > 0 && !initializedRows.has(`detail-${productId}`)) {
                        // Marca come inizializzata
                        initializedRows.add(`detail-${productId}`);

                        // Reinizializza i controlli nella nuova riga di dettaglio
                        ReinitializeDetailRowControls($detailRow, urlAggiornamento, contextRowSelector, refreshTotaliUrl);

                        // Pulisci il set quando la riga viene chiusa
                        const observer = new MutationObserver((mutations) => {
                            mutations.forEach((mutation) => {
                                if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
                                    mutation.removedNodes.forEach((node) => {
                                        if ($(node).hasClass('riga-dettaglioordine')) {
                                            initializedRows.delete(`detail-${productId}`);
                                            observer.disconnect();
                                        }
                                    });
                                }
                            });
                        });

                        observer.observe($currentRow.parent()[0], { childList: true });
                    }
                }, 300); // Attendi che il contenuto sia caricato
            });
        }

        function ReinitializeDetailRowControls(
            $detailRow: JQuery<HTMLElement>,
            urlAggiornamento: string,
            contextRowSelector: string,
            refreshTotaliUrl: string
        ): void {
            // Reinizializza i controlli UI (se usi altri plugin)
            if (typeof Controlli !== 'undefined' && Controlli.Utility) {
                Controlli.Utility.DestroyControl($detailRow);
                Controlli.Utility.RefreshControl($detailRow);
            }
        }

        function SetupQuantityChangeHandler(
            urlAggiornamento: string,
            contextRowSelector: string,
            refreshTotaliUrl: string,
            mainBodyRefresh: string,
            refreshUrl: string,
            selector?: JQuery<HTMLElement | NodeList>
        ): void {
            // Questa funzione ora è meno importante perché usiamo event delegation
            // Ma la manteniamo per compatibilità con elementi già presenti
            const $qtyInputs = $(selector)
                ? $(selector).find(`[data-${contextRowSelector}-${defaultDataAttrConfig.qtaSelector}]`)
                : $(`[data-${contextRowSelector}-${defaultDataAttrConfig.qtaSelector}]`);

            $qtyInputs.each(function () {
                const $input = $(this);
                if (!$input.data('carrello-initialized')) {
                    $input.data('carrello-initialized', true);
                    // Gli eventi sono già gestiti tramite delegation
                }
            });
        }

        function SetupAddProductHandler(
            urlAggiornamento: string,
            contextRowSelector: string,
            refreshTotaliUrl: string,
            selector?: JQuery<HTMLElement | NodeList>
        ): void {
            // Questa funzione ora marca solo gli elementi come inizializzati
            // Gli eventi sono gestiti tramite delegation
            const buttonSelector = `[data-${contextRowSelector}-${defaultDataAttrConfig.btnAddProduct}]`;
            const $buttons = selector
                ? selector.find(buttonSelector)
                : $(buttonSelector);

            $buttons.each(function () {
                $(this).data('carrello-initialized', true);
            });
        }

        function UpdateRigaOrdine(
            urlAggiornamento: string,
            contextRowSelector: string,
            selector: JQuery<HTMLElement>
        ): AggiuntaArticoliCarrelloResponse | {} {
            // Trova la riga che contiene i dati
            const $currentRow = selector.closest('tr');
            let $dataRow = $currentRow;

            // Se la riga corrente non ha i dati, cercali
            if (!$currentRow.data(`${contextRowSelector}-${defaultDataAttrConfig.idProdotto}`)) {
                // Potrebbe essere in una tabella annidata, cerca nella stessa riga
                $dataRow = $currentRow.find(`[data-${contextRowSelector}-${defaultDataAttrConfig.idProdotto}]`).closest('tr');

                // Se ancora non trova, usa la riga corrente
                if ($dataRow.length === 0) {
                    $dataRow = $currentRow;
                }
            }

            // Estrai i dati
            const idProdotto = $dataRow.data(`${contextRowSelector}-${defaultDataAttrConfig.idProdotto}`) ||
                $currentRow.find(`[data-${contextRowSelector}-${defaultDataAttrConfig.qtaSelector}]`).first().data(`${contextRowSelector}-${defaultDataAttrConfig.qtaSelector}`);
            const idListino = $dataRow.data(`${contextRowSelector}-${defaultDataAttrConfig.idListino}`) || 0;
            const idUnitaMisura = $dataRow.data(`${contextRowSelector}-${defaultDataAttrConfig.idUnitaMisura}`) || 0;
            const idListaRiga = $dataRow.data(`${contextRowSelector}-${defaultDataAttrConfig.idRigaLista}`);

            // Trova la quantità
            const $qtyInput = $currentRow.find(`input[data-${contextRowSelector}-${defaultDataAttrConfig.qtaSelector}="${idProdotto}"], input[data-${contextRowSelector}-${defaultDataAttrConfig.qtaSelector}]`).first();
            var quantita = 1;
            if ($qtyInput) {
                quantita = parseInt($qtyInput.val() as string);
            }

            const $prezzoInput = $currentRow.find(`#prezzo-input-${idProdotto}`).first();
            var prezzo = NaN;
            if ($prezzoInput) {
                prezzo = parseFloat($prezzoInput.val() as string);
            }

            const $editButton = $currentRow.find(`[data-sav-edit-price="${idProdotto}"]`).first();
            var prezzoOriginale = NaN;
            if ($editButton.data('prezzo-originale')) {
                prezzoOriginale = parseFloat($editButton.data('prezzo-originale').replace(",", ".") as string);
            }

            //aggiunto per rilevare la modifica del prezzo anche durante l'aggiornamento della quantità nel carrello
            var isPrezzoModificato = false;
            if ($currentRow.data('sav-prezzo-articolo')) {
                isPrezzoModificato = true;
                prezzo = parseFloat($currentRow.data('sav-prezzo-articolo').toString().replace(",", ".") as string); //toString necessario, NON ELIMINARE
            }

            if (quantita > 0 && idProdotto) {
                const request = new AggiuntaArticoliCarrelloRequest(
                    String(idProdotto),
                    quantita,
                    Number(idListino),
                    Number(idUnitaMisura),
                    Boolean((!isNaN(prezzoOriginale) && !isNaN(prezzo) && prezzoOriginale !== prezzo) || isPrezzoModificato),
                    !isNaN(prezzo) ? prezzo.toString().replace(".", ",") : (!isNaN(prezzoOriginale) ? prezzoOriginale.toString().replace(".", ",") : ""),
                    idListaRiga ? Number(idListaRiga) : undefined
                );

                return Controlli.Ajax.AjaxPostJSON(urlAggiornamento, request) as unknown as AggiuntaArticoliCarrelloResponse;
            }

            return {};
        }
    }
}